enum EIppAASAuthorityInformationActionType {
	FetchIppAASAuthorityInformationData = 'fetchIppAASAuthorityInformationData'
}

export default EIppAASAuthorityInformationActionType;
